module.exports = __webpack_public_path__ + "static/media/pointDefault.018fe1e3.png";